module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/monthly-attendance-details/monthly-att-det/monthly-att-det.component.css
// module id = ./src/app/hrms/payroll/monthly-attendance-details/monthly-att-det/monthly-att-det.component.css
// module chunks = main